import axios from "axios";

import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { showToast } from "../../utill/utill";
import { mapAuthError } from "../../lib/auth/authErrorMessage";

const IconStar = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
        <path
            d="M5 0.5L6.2 3.6L9.5 3.6L6.85 5.5L7.85 8.6L5 6.7L2.15 8.6L3.15 5.5L0.5 3.6L3.8 3.6L5 0.5Z"
            fill="var(--fg-anti-red, #ff1500)"
        />
    </svg>
);

const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path
            d="M2.5 7L5.5 10L11.5 4"
            stroke="#ffffff"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const IconChevronRight = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
        <path
            d="M3.5 2L7 5L3.5 8"
            stroke="var(--fg-text-gray, #838383)"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function UserSignup() {
    const navigate = useNavigate();
    const [step, setStep] = useState('terms');
    const [agreeService, setAgreeService] = useState(false);
    const [agreeMarketing, setAgreeMarketing] = useState(false);
    const [agreeBenefit, setAgreeBenefit] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        verifyCode: '',
        agreeToTerms: false,
    });
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState({});
    const [emailChecked, setEmailChecked] = useState(false);
    const [checkingEmail, setCheckingEmail] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [showVerifyCode, setShowVerifyCode] = useState(false);
    const [timer, setTimer] = useState(180);
    const [timerActive, setTimerActive] = useState(false);
    const [sendingCode, setSendingCode] = useState(false);
    const [verificationToken, setVerificationToken] = useState('');
    const [showTermsModal, setShowTermsModal] = useState(false);
    const [showPrivacyModal, setShowPrivacyModal] = useState(false);
    const [showBenefitModal, setShowBenefitModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const agreeAll = agreeService && agreeMarketing && agreeBenefit;

    const handleAgreeAll = () => {
        const next = !agreeAll;
        setAgreeService(next);
        setAgreeMarketing(next);
        setAgreeBenefit(next);
    };

    const handleTermsNext = () => {
        if (!agreeService) {
            showToast('필수 약관에 동의해주세요.', 'error');
            return;
        }
        setStep('info');
    };

    // 타이머
    useEffect(() => {
        let interval = null;
        if (timerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer(t => t - 1);
            }, 1000);
        } else if (timer === 0) {
            setTimerActive(false);
            setShowVerifyCode(false);
        }
        return () => clearInterval(interval);
    }, [timerActive, timer]);

    const handleTermsClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowTermsModal(true);
    };

    const handlePrivacyClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowPrivacyModal(true);
    };

    const handleBenefitClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowBenefitModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const nextValue = type === 'checkbox' ? checked : value;

        setFormData(prev => ({ ...prev, [name]: nextValue }));

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
        if (success[name]) {
            setSuccess(prev => ({ ...prev, [name]: false }));
        }

        if (name === 'email') {
            if (emailChecked) setEmailChecked(false);
            if (success.emailCheck) setSuccess(prev => ({ ...prev, emailCheck: false }));
        }

        if (name === 'passwordConfirm') {
            checkPasswordMatch(nextValue, formData.password);
        }
        if (name === 'password' && formData.passwordConfirm) {
            checkPasswordMatch(formData.passwordConfirm, nextValue);
        }
    };

    const checkPasswordMatch = (passwordConfirm, password) => {
        if (!passwordConfirm) {
            setSuccess(prev => ({ ...prev, passwordConfirm: false }));
            return;
        }
        if (password === passwordConfirm) {
            setSuccess(prev => ({ ...prev, passwordConfirm: true }));
            setErrors(prev => ({ ...prev, passwordConfirm: '' }));
        } else {
            setSuccess(prev => ({ ...prev, passwordConfirm: false }));
        }
    };

    // TODO: 백엔드 중복 확인 API 준비되면 주석 해제
    // const checkEmailDuplicate = () => {
    //     if (!formData.email.trim()) {
    //         setErrors(prev => ({ ...prev, email: '이메일을 입력해주세요.' }));
    //         return;
    //     }
    //     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //         setErrors(prev => ({ ...prev, email: '올바른 이메일 형식이 아닙니다.' }));
    //         return;
    //     }
    //
    //     setCheckingEmail(true);
    //     setErrors(prev => ({ ...prev, email: '' }));
    //     setSuccess(prev => ({ ...prev, emailCheck: false }));
    //
    //     axios.post(`${process.env.REACT_APP_API_URL}/user/email-confirm`, {
    //         email: formData.email,
    //     }).then(() => {
    //         setEmailChecked(true);
    //         setSuccess(prev => ({ ...prev, emailCheck: true }));
    //         setErrors(prev => ({ ...prev, email: '' }));
    //         setCheckingEmail(false);
    //     }).catch(error => {
    //         setCheckingEmail(false);
    //         setEmailChecked(false);
    //         if (error.response) {
    //             const errorMessage = error.response.data?.message || error.response.data?.detail || '이미 사용 중인 이메일입니다.';
    //             setErrors(prev => ({ ...prev, email: errorMessage }));
    //         } else {
    //             setErrors(prev => ({ ...prev, email: '네트워크 오류가 발생했습니다.' }));
    //         }
    //     });
    // };

    const sendVerificationCode = () => {
        if (!formData.email.trim()) {
            setErrors(prev => ({ ...prev, email: '이메일을 입력해주세요.' }));
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            setErrors(prev => ({ ...prev, email: '올바른 이메일 형식이 아닙니다.' }));
            return;
        }
        // TODO: 백엔드 중복 확인 API 준비되면 주석 해제
        // if (!emailChecked) {
        //     setErrors(prev => ({ ...prev, email: '이메일 중복 확인을 먼저 진행해주세요.' }));
        //     return;
        // }
        if (!formData.password) {
            setErrors(prev => ({ ...prev, password: '비밀번호를 입력해주세요.' }));
            return;
        }
        if (formData.password.length < 8) {
            setErrors(prev => ({ ...prev, password: '비밀번호는 8자 이상이어야 합니다.' }));
            return;
        }
        if (formData.password !== formData.passwordConfirm) {
            setErrors(prev => ({ ...prev, passwordConfirm: '비밀번호가 일치하지 않습니다.' }));
            return;
        }
        if (!formData.name.trim()) {
            setErrors(prev => ({ ...prev, name: '이름을 입력해주세요.' }));
            return;
        }
        if (!formData.agreeToTerms) {
            showToast('인증 약관에 동의해주세요.', 'error');
            return;
        }

        setSendingCode(true);
        setErrors(prev => ({ ...prev, email: '' }));
        setSuccess(prev => ({ ...prev, emailSend: false }));

        axios.post(`${process.env.REACT_APP_API_URL}/user/email/send-code`, {
            email: formData.email,
        }).then(response => {
            const data = response.data;
            setVerificationToken(data.verification_token);
            setShowVerifyCode(true);
            setTimerActive(true);
            setTimer(180);
            setSuccess(prev => ({ ...prev, emailSend: true }));
            setErrors(prev => ({ ...prev, email: '' }));
            setSendingCode(false);
        }).catch(error => {
            setSendingCode(false);
            // 백엔드 detail(영문 식별자)을 한글로 매핑. 409 email already exists 등.
            setErrors(prev => ({ ...prev, email: mapAuthError(error, '인증번호 발송에 실패했습니다.') }));
        });
    };

    const verifyCode = () => {
        if (!formData.verifyCode.trim()) {
            setErrors(prev => ({ ...prev, verifyCode: '인증번호를 입력해주세요.' }));
            return;
        }

        axios.post(`${process.env.REACT_APP_API_URL}/user/email/verify-code`, {
            email: formData.email,
            code: formData.verifyCode,
            verification_token: verificationToken,
        }).then(() => {
            setEmailVerified(true);
            setTimerActive(false);
            setShowVerifyCode(false);
            setSuccess(prev => ({ ...prev, verify: true }));
            setErrors(prev => ({ ...prev, verifyCode: '' }));
        }).catch(error => {
            // invalid code / code expired / email mismatch / invalid token 등을 구분해 안내.
            setErrors(prev => ({ ...prev, verifyCode: mapAuthError(error, '인증번호가 일치하지 않습니다.') }));
        });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) newErrors.name = '이름을 입력해주세요.';
        if (!formData.email.trim()) {
            newErrors.email = '이메일을 입력해주세요.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = '올바른 이메일 형식이 아닙니다.';
        } else if (!emailVerified) {
            newErrors.email = '이메일 인증을 완료해주세요.';
        }
        if (!formData.password) {
            newErrors.password = '비밀번호를 입력해주세요.';
        } else if (formData.password.length < 8) {
            newErrors.password = '비밀번호는 8자 이상이어야 합니다.';
        }
        if (!formData.passwordConfirm) {
            newErrors.passwordConfirm = '비밀번호 확인을 입력해주세요.';
        } else if (formData.password !== formData.passwordConfirm) {
            newErrors.passwordConfirm = '비밀번호가 일치하지 않습니다.';
        }
        if (!formData.agreeToTerms) newErrors.agreeToTerms = '인증 약관에 동의해주세요.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        if (!validateForm()) return;
        if (!verificationToken || verificationToken.trim() === '') {
            setErrors(prev => ({ ...prev, email: '이메일 인증을 완료해주세요.' }));
            return;
        }

        setIsSubmitting(true);
        axios.post(`${process.env.REACT_APP_API_URL}/user/signup`, {
            email: formData.email,
            password: formData.password,
            full_name: formData.name,
            status: 'active',
            default_role: 'member',
            // 약관 화면(step='terms') 동의값. 필수 약관은 게이트로 true 보장,
            // 선택 2종은 거부 이력도 남기도록 false도 명시 전송.
            terms_agreed: agreeService,
            marketing_privacy_agreed: agreeMarketing,
            marketing_email_agreed: agreeBenefit,
        }).then(() => {
            showToast('회원가입이 완료되었습니다.', 'success');
            navigate('/login');
        }).catch(error => {
            setIsSubmitting(false);
            // 409 email already exists / 400 password required 등을 한글로 매핑.
            showToast(mapAuthError(error, '회원가입에 실패했습니다.'), 'error');
        });
    };

    const formatTimer = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <Helmet>
                <title>회원가입 - GrowFit</title>
                <meta name="description" content="GrowFit AI 실습 플랫폼 회원가입. 무료로 가입하고 ChatGPT, Claude, Gemini 등 다양한 AI를 활용한 프로젝트 기반 학습을 시작하세요." />
                <link rel="canonical" href="https://growfit.kr/register" />
                <meta property="og:title" content="회원가입 - GrowFit" />
                <meta property="og:description" content="GrowFit AI 실습 플랫폼 무료 회원가입." />
                <meta property="og:url" content="https://growfit.kr/register" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className={`signup2026${step === 'terms' ? ' signup2026--centered' : ''}`}>
                <main className="signup2026__main">
                    {step === 'terms' && (
                        <section className="signup2026__section signup2026__section--terms">
                            <Link to="/" className="signup2026__brand" aria-label="GrowFit 홈으로 이동">
                                <img
                                    className="signup2026__brand-logo"
                                    src="/images/growfit-star.png"
                                    alt="GrowFit"
                                />
                                <span className="signup2026__brand-text">GrowFit</span>
                            </Link>

                            <ul className="signup2026__agree-list">
                                <li className="signup2026__agree-row signup2026__agree-row--all">
                                    <button
                                        type="button"
                                        className={`signup2026__agree-check ${agreeAll ? 'signup2026__agree-check--active' : ''}`}
                                        onClick={handleAgreeAll}
                                        aria-pressed={agreeAll}
                                        aria-label="전체 동의하기"
                                    >
                                        <IconCheck />
                                    </button>
                                    <span className="signup2026__agree-text signup2026__agree-text--all">
                                        전체 동의하기
                                    </span>
                                </li>

                                <li className="signup2026__agree-row">
                                    <button
                                        type="button"
                                        className={`signup2026__agree-check ${agreeService ? 'signup2026__agree-check--active' : ''}`}
                                        onClick={() => setAgreeService(v => !v)}
                                        aria-pressed={agreeService}
                                        aria-label="그로우핏 이용약관 동의 (필수)"
                                    >
                                        <IconCheck />
                                    </button>
                                    <span className="signup2026__agree-tag signup2026__agree-tag--required">
                                        필수
                                    </span>
                                    <span className="signup2026__agree-text">그로우핏 이용약관</span>
                                    <button
                                        type="button"
                                        className="signup2026__agree-view"
                                        onClick={handleTermsClick}
                                    >
                                        보기
                                    </button>
                                </li>

                                <li className="signup2026__agree-row signup2026__agree-row--two-line">
                                    <button
                                        type="button"
                                        className={`signup2026__agree-check ${agreeMarketing ? 'signup2026__agree-check--active' : ''}`}
                                        onClick={() => setAgreeMarketing(v => !v)}
                                        aria-pressed={agreeMarketing}
                                        aria-label="개인정보 수집 및 동의 (선택)"
                                    >
                                        <IconCheck />
                                    </button>
                                    <div className="signup2026__agree-text-group">
                                        <div className="signup2026__agree-text-row">
                                            <span className="signup2026__agree-tag">선택</span>
                                            <span className="signup2026__agree-text">
                                                개인정보 수집 및 동의
                                            </span>
                                        </div>
                                        <span className="signup2026__agree-subtext">
                                            이벤트 및 광고성 정보 수신 동의
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="signup2026__agree-view"
                                        onClick={handlePrivacyClick}
                                    >
                                        보기
                                    </button>
                                </li>

                                <li className="signup2026__agree-row signup2026__agree-row--two-line">
                                    <button
                                        type="button"
                                        className={`signup2026__agree-check ${agreeBenefit ? 'signup2026__agree-check--active' : ''}`}
                                        onClick={() => setAgreeBenefit(v => !v)}
                                        aria-pressed={agreeBenefit}
                                        aria-label="AI 뉴스 및 업데이트 받아보기 (선택)"
                                    >
                                        <IconCheck />
                                    </button>
                                    <div className="signup2026__agree-text-group">
                                        <div className="signup2026__agree-text-row">
                                            <span className="signup2026__agree-tag">선택</span>
                                            <span className="signup2026__agree-text">
                                                AI 뉴스 및 업데이트 받아보기
                                            </span>
                                        </div>
                                        <span className="signup2026__agree-subtext">
                                            그로우핏의 신규 기능·업데이트 소식과 이벤트·할인 등 회원 전용 혜택 정보를 이메일로 받아보는 것에 동의합니다.
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="signup2026__agree-view"
                                        onClick={handleBenefitClick}
                                    >
                                        보기
                                    </button>
                                </li>
                            </ul>

                            <button
                                type="button"
                                className="signup2026__submit"
                                onClick={handleTermsNext}
                                disabled={!agreeService}
                            >
                                다음
                            </button>
                        </section>
                    )}

                    {step === 'info' && (
                    <form className="signup2026__form" onSubmit={handleSubmit} noValidate>
                        {/* ─── 필수 정보 입력 ─── */}
                        <section className="signup2026__section">
                            <Link to="/" className="signup2026__brand" aria-label="GrowFit 홈으로 이동">
                                <img
                                    className="signup2026__brand-logo"
                                    src="/images/growfit-star.png"
                                    alt="GrowFit"
                                />
                                <span className="signup2026__brand-text">GrowFit</span>
                            </Link>

                            <h1 className="signup2026__title">필수 정보 입력</h1>

                            <div className="signup2026__field">
                                <label className="signup2026__field-label" htmlFor="email">
                                    <span>이메일</span>
                                    <IconStar />
                                </label>
                                <div className="signup2026__verify-row">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className={`signup2026__input ${errors.email ? 'signup2026__input--error' : ''}`}
                                        placeholder="example@growfit.kr"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        disabled={emailVerified}
                                        required
                                    />
                                    {/* TODO: 백엔드 중복 확인 API 준비되면 주석 해제
                                    <button
                                        type="button"
                                        className="signup2026__verify-btn"
                                        onClick={checkEmailDuplicate}
                                        disabled={emailVerified || checkingEmail || emailChecked}
                                    >
                                        {checkingEmail
                                            ? '확인 중...'
                                            : emailChecked
                                                ? '확인 완료'
                                                : '중복 확인'}
                                    </button>
                                    */}
                                </div>
                                {errors.email && (
                                    <p className="signup2026__field-error">{errors.email}</p>
                                )}
                                {success.emailCheck && !errors.email && !emailVerified && (
                                    <p className="signup2026__field-hint signup2026__field-hint--ok">
                                        사용 가능한 이메일입니다.
                                    </p>
                                )}
                                {success.emailSend && !emailVerified && !errors.email && (
                                    <p className="signup2026__field-hint">인증번호가 발송되었습니다.</p>
                                )}
                            </div>

                            <div className="signup2026__field">
                                <label className="signup2026__field-label" htmlFor="password">
                                    <span>비밀번호</span>
                                    <IconStar />
                                </label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="new-password"
                                    className={`signup2026__input ${errors.password ? 'signup2026__input--error' : ''}`}
                                    placeholder="영문, 숫자가 혼용된 8자리 이상의 비밀번호를 입력하세요."
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errors.password && (
                                    <p className="signup2026__field-error">{errors.password}</p>
                                )}
                            </div>

                            <div className="signup2026__field">
                                <label className="signup2026__field-label" htmlFor="passwordConfirm">
                                    <span>비밀번호 재입력</span>
                                    <IconStar />
                                </label>
                                <input
                                    id="passwordConfirm"
                                    name="passwordConfirm"
                                    type="password"
                                    autoComplete="new-password"
                                    className={`signup2026__input ${errors.passwordConfirm ? 'signup2026__input--error' : ''}`}
                                    placeholder="비밀번호를 재입력하세요."
                                    value={formData.passwordConfirm}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errors.passwordConfirm && (
                                    <p className="signup2026__field-error">{errors.passwordConfirm}</p>
                                )}
                                {!errors.passwordConfirm && success.passwordConfirm && formData.passwordConfirm && (
                                    <p className="signup2026__field-hint signup2026__field-hint--ok">
                                        비밀번호가 일치합니다.
                                    </p>
                                )}
                            </div>
                        </section>

                        {/* ─── 실명 인증 ─── */}
                        <section className="signup2026__section">
                            <div className="signup2026__field">
                                <label className="signup2026__field-label" htmlFor="name">
                                    <span>이름</span>
                                    <IconStar />
                                </label>
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    autoComplete="name"
                                    className={`signup2026__input ${errors.name ? 'signup2026__input--error' : ''}`}
                                    placeholder="이름을 입력하세요."
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errors.name && (
                                    <p className="signup2026__field-error">{errors.name}</p>
                                )}
                            </div>

                            <div className="signup2026__terms-box">
                                <label className="signup2026__check">
                                    <input
                                        type="checkbox"
                                        name="agreeToTerms"
                                        checked={formData.agreeToTerms}
                                        onChange={handleInputChange}
                                    />
                                    <span className="signup2026__check-box" aria-hidden="true">
                                        <IconCheck />
                                    </span>
                                </label>
                                <div className="signup2026__terms-content">
                                    <p className="signup2026__terms-title">인증 약관 전체 동의</p>
                                    <ul className="signup2026__terms-list">
                                        <li>
                                            <button type="button" onClick={handlePrivacyClick}>
                                                <span>개인정보 이용</span>
                                                <IconChevronRight />
                                            </button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={handlePrivacyClick}>
                                                <span>고유식별정보 처리</span>
                                                <IconChevronRight />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                onClick={() => showToast('통신사 이용약관은 준비 중입니다.', 'info')}
                                            >
                                                <span>통신사 이용약관</span>
                                                <IconChevronRight />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                onClick={() => showToast('인증사 이용약관은 준비 중입니다.', 'info')}
                                            >
                                                <span>인증사 이용약관</span>
                                                <IconChevronRight />
                                            </button>
                                        </li>
                                        <li>
                                            <button type="button" onClick={handleTermsClick}>
                                                <span>그로우핏 개인정보수집</span>
                                                <IconChevronRight />
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {showVerifyCode && !emailVerified && (
                                <div className="signup2026__field">
                                    <label className="signup2026__field-label" htmlFor="verifyCode">
                                        <span>인증번호</span>
                                        <IconStar />
                                    </label>
                                    <div className="signup2026__verify-row">
                                        <input
                                            id="verifyCode"
                                            name="verifyCode"
                                            type="text"
                                            inputMode="numeric"
                                            className={`signup2026__input ${errors.verifyCode ? 'signup2026__input--error' : ''}`}
                                            placeholder="인증번호 6자리"
                                            value={formData.verifyCode}
                                            onChange={handleInputChange}
                                            maxLength={6}
                                        />
                                        <button
                                            type="button"
                                            className="signup2026__verify-btn"
                                            onClick={verifyCode}
                                            disabled={!timerActive && timer === 0}
                                        >
                                            확인
                                        </button>
                                    </div>
                                    {timerActive && timer > 0 && (
                                        <p className="signup2026__field-hint">남은 시간: {formatTimer(timer)}</p>
                                    )}
                                    {errors.verifyCode && (
                                        <p className="signup2026__field-error">{errors.verifyCode}</p>
                                    )}
                                </div>
                            )}

                            {!emailVerified && (
                                <button
                                    type="button"
                                    className="signup2026__submit"
                                    onClick={sendVerificationCode}
                                    disabled={sendingCode}
                                >
                                    {sendingCode
                                        ? '발송 중...'
                                        : timerActive
                                            ? `재발송 (${formatTimer(timer)})`
                                            : '인증요청'}
                                </button>
                            )}
                        </section>

                        {/* ─── 인증 완료 + 다음 ─── */}
                        {emailVerified && (
                            <section className="signup2026__section signup2026__section--complete">
                                <p className="signup2026__complete-text">인증이 완료되었습니다.</p>
                                <button
                                    type="submit"
                                    className="signup2026__submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? '처리 중...' : '다음'}
                                </button>
                            </section>
                        )}
                    </form>
                    )}

                    <p className="signup2026__login-link">
                        <span>이미 계정이 있으신가요?</span>
                        <Link to="/login">로그인</Link>
                    </p>
                </main>
            </div>

            {isSubmitting && (
                <div className="signup2026__loading-overlay" role="dialog" aria-modal="true" aria-live="polite">
                    <div className="signup2026__loading-modal">
                        <div className="signup2026__loading-spinner" aria-hidden="true" />
                        <p className="signup2026__loading-title">처리 중입니다</p>
                        <p className="signup2026__loading-desc">회원가입을 진행하고 있어요. 잠시만 기다려주세요.</p>
                    </div>
                </div>
            )}

            {showTermsModal && (
                <div className="terms-modal-overlay" onClick={() => setShowTermsModal(false)}>
                    <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="terms-modal__header">
                            <h2 className="terms-modal__title">GrowFit 서비스 이용약관</h2>
                            <button className="terms-modal__close" onClick={() => setShowTermsModal(false)} aria-label="닫기">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 6L6 18M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="terms-modal__body">
                            <p><strong>시행일: 2026년 03월 05일</strong></p>

                            <h3>제1조 (목적)</h3>
                            <p>본 약관은 GrowFit(이하 "회사")이 제공하는 AI 실습 플랫폼 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.</p>

                            <h3>제2조 (서비스 내용)</h3>
                            <p>회사는 AI 실습 및 교육을 위한 다음과 같은 기능을 제공합니다.</p>
                            <ul>
                                <li>LLM 기반 실습(채팅/세션 실행)</li>
                                <li>모델 선택 및 파라미터 설정</li>
                                <li>프롬프트·에이전트 구성 및 실행</li>
                                <li>지식베이스(RAG) 문서 업로드 및 검색</li>
                                <li>비교 실험(A/B), 학습 기록 관리</li>
                                <li>사용량(토큰·호출·비용) 통계 제공</li>
                                <li>클래스·학생·조직 관리 기능</li>
                            </ul>
                            <p>서비스 기능은 정책에 따라 변경될 수 있습니다.</p>

                            <h3>제3조 (회원가입 및 이용계약)</h3>
                            <ul>
                                <li>회원가입은 약관 동의 후 회사의 승낙으로 성립됩니다.</li>
                                <li>허위 정보 제공, 타인 정보 도용, 비정상적 목적 이용 시 가입이 제한될 수 있습니다.</li>
                                <li>만 14세 미만은 법정대리인 동의가 필요합니다.</li>
                                <li>회사는 역할(조직관리자, 강사, 학생 등)에 따라 기능 및 사용 한도를 다르게 설정할 수 있습니다.</li>
                            </ul>

                            <h3>제4조 (회원의 의무)</h3>
                            <p>회원은 다음 행위를 하여서는 안 됩니다.</p>
                            <ul>
                                <li>타인 정보 도용</li>
                                <li>저작권 및 지적재산권 침해</li>
                                <li>불법·유해 콘텐츠 게시</li>
                                <li>서비스 재판매·재배포</li>
                                <li>자동화 도구를 이용한 과도한 호출</li>
                                <li>보안 우회 및 비정상 트래픽 유발</li>
                            </ul>
                            <p>위반 시 서비스 이용이 제한될 수 있습니다.</p>

                            <h3>제5조 (계정 관리)</h3>
                            <p>아이디 및 비밀번호 관리 책임은 회원에게 있으며, 도용 발생 시 즉시 회사에 통지해야 합니다.</p>

                            <h3>제6조 (콘텐츠 권리)</h3>
                            <ul>
                                <li>회원이 업로드·생성한 콘텐츠의 권리는 원칙적으로 회원에게 있습니다.</li>
                                <li>회사는 서비스 운영·저장·보안·통계 목적 범위 내에서 해당 콘텐츠를 사용할 수 있습니다.</li>
                                <li>회원은 제3자의 권리를 침해하지 않아야 합니다.</li>
                            </ul>

                            <h3>제7조 (사용량 및 이용 제한)</h3>
                            <ul>
                                <li>회사는 안정적 운영을 위해 사용량(토큰, 호출 횟수 등)을 제한할 수 있습니다.</li>
                                <li>비정상 사용, 과도한 자동 호출, 보안 위협 발생 시 사전 통지 없이 이용이 제한될 수 있습니다.</li>
                                <li>회원은 예산·사용량 가드레일 기능을 활용하여 관리할 책임이 있습니다.</li>
                            </ul>

                            <h3>제8조 (외부 서비스 연동)</h3>
                            <ul>
                                <li>서비스는 OpenAI, Anthropic, Google 등 외부 AI 제공자의 API와 연동될 수 있습니다.</li>
                                <li>기능 수행을 위해 회원 입력 데이터가 외부 제공자에게 전송될 수 있습니다.</li>
                                <li>외부 제공자의 정책 변경·장애로 인한 영향에 대해 회사는 법령이 허용하는 범위 내에서 책임을 제한합니다.</li>
                            </ul>

                            <h3>제9조 (결제 및 환불)</h3>
                            <ul>
                                <li>유료 서비스는 서비스 내 안내된 방식으로 결제합니다.</li>
                                <li>이용 내역이 없는 경우 7일 이내 청약철회가 가능합니다.</li>
                                <li>이미 사용한 서비스에 대해서는 환불이 제한될 수 있습니다.</li>
                            </ul>

                            <h3>제10조 (면책사항)</h3>
                            <ul>
                                <li>LLM 출력물은 확률적 생성 결과로 정확성·완전성이 보장되지 않습니다.</li>
                                <li>회원은 출력 결과를 검증 후 사용해야 합니다.</li>
                                <li>회사는 불가항력, 외부 서비스 장애, 회원 귀책 사유로 인한 손해에 대해 법령이 허용하는 범위 내에서 책임을 제한합니다.</li>
                                <li>유료 회원의 경우 손해배상 한도는 최근 12개월간 지급한 이용대금 범위 내로 제한될 수 있습니다.</li>
                            </ul>

                            <h3>제11조 (계약 해지)</h3>
                            <p>회원은 언제든지 탈퇴할 수 있으며, 관련 법령에 따라 일부 정보는 일정 기간 보관될 수 있습니다.</p>

                            <h3>제12조 (준거법 및 관할)</h3>
                            <p>본 약관은 대한민국 법률에 따르며, 분쟁 발생 시 대한민국 법원을 관할 법원으로 합니다.</p>

                            <h3>부칙</h3>
                            <p>본 약관은 2026년 03월 05일부터 시행됩니다.</p>
                        </div>
                        <p className="terms-modal__footer-text">
                            본 약관에 동의하시면 회원가입 페이지에서 동의 체크박스를 선택해 주세요.
                        </p>
                    </div>
                </div>
            )}

            {showPrivacyModal && (
                <div className="terms-modal-overlay" onClick={() => setShowPrivacyModal(false)}>
                    <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="terms-modal__header">
                            <h2 className="terms-modal__title">개인정보처리방침</h2>
                            <button className="terms-modal__close" onClick={() => setShowPrivacyModal(false)} aria-label="닫기">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 6L6 18M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="terms-modal__body">
                            <h3>1. 수집하는 개인정보의 항목 및 수집방법</h3>
                            <p><strong>가. 수집하는 개인정보의 항목</strong></p>
                            <p>GrowFit은 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 최초 회원가입 당시 아래와 같은 최소한의 개인정보를 필수항목으로 수집하고 있습니다.</p>
                            <ul>
                                <li><strong>필수항목:</strong> 이름, 이메일, 비밀번호</li>
                                <li><strong>선택항목:</strong> 가입경로 (선택항목은 입력하지 않아도 회원가입이 가능합니다.)</li>
                            </ul>
                            <p>서비스 이용과정이나 사업처리 과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.</p>
                            <ul>
                                <li>IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
                            </ul>

                            <h3>2. 개인정보의 수집 및 이용목적</h3>
                            <p><strong>가. 회원관리</strong></p>
                            <p>회원제 서비스 제공, 개인식별, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용 행위 제재, 가입의사 확인, 가입 및 가입횟수 제한, 고지사항 전달, 회원탈퇴 의사의 확인, 접속빈도 파악, 회원의 서비스이용에 대한 통계</p>
                            <p><strong>나. AI 교육 서비스 제공</strong></p>
                            <p>AI 모델 실습 환경 제공, 프로젝트 관리, 지식베이스 활용, 학습 이력 관리, 강사-학생 매칭 및 수업 운영</p>

                            <h3>3. 개인정보의 공유 및 제공</h3>
                            <p>GrowFit은 이용자들의 개인정보를 "2. 개인정보의 수집 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                            <ul>
                                <li>이용자가 사전에 동의한 경우</li>
                                <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                            </ul>

                            <h3>4. 개인정보의 보유 및 이용기간</h3>
                            <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단, 다음의 정보에 대해서는 아래의 보존 이유를 위해 명시한 기간 동안 보존합니다.</p>
                            <ul>
                                <li><strong>보존 항목:</strong> 이메일</li>
                                <li><strong>보존 이유:</strong> 부정 가입 및 이용 방지</li>
                                <li><strong>보존 기간:</strong> 1년</li>
                            </ul>

                            <h3>5. 개인정보 파기절차 및 방법</h3>
                            <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.</p>
                            <p><strong>가. 파기절차</strong></p>
                            <ul>
                                <li>이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후 파기됩니다.</li>
                                <li>동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
                            </ul>
                            <p><strong>나. 파기방법</strong></p>
                            <ul>
                                <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
                                <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                            </ul>

                            <h3>6. 이용자 및 법정대리인의 권리와 그 행사방법</h3>
                            <p>이용자 및 법정 대리인은 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 회사의 개인정보의 처리에 동의하지 않는 경우 동의를 거부하거나 가입해지(회원탈퇴)를 요청하실 수 있습니다. 다만, 그러한 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.</p>
                            <p>이용자의 개인정보 조회, 수정을 위해서는 '회원정보수정'을, 가입해지(동의철회)를 위해서는 '회원탈퇴'를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.</p>
                            <p>혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</p>

                            <h3>7. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h3>
                            <p><strong>가. 쿠키란?</strong></p>
                            <p>회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.</p>
                            <p><strong>나. 쿠키 사용 목적</strong></p>
                            <p>이용자들이 방문한 GrowFit의 각 서비스와 웹 사이트들에 대한 방문, 이용자 규모 등을 파악하여 이용자에게 맞춤형 정보를 제공하기 위해 사용합니다.</p>
                            <p><strong>다. 쿠키의 설치/운영 및 거부</strong></p>
                            <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 다만, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.</p>

                            <h3>8. 개인정보의 기술적/관리적 보호 대책</h3>
                            <p>GrowFit은 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.</p>
                            <p><strong>가. 비밀번호 암호화</strong></p>
                            <p>GrowFit 회원의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이 알고 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다.</p>
                            <p><strong>나. 해킹 등에 대비한 대책</strong></p>
                            <p>GrowFit은 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.</p>

                            <h3>9. 개인정보관리책임자 및 담당자의 연락처</h3>
                            <p>귀하께서는 GrowFit의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.</p>
                            <ul>
                                <li><strong>개인정보 관리책임자 (정)</strong></li>
                                <li>이름: 박동민</li>
                                <li>소속: (주)비씨티원 (BCT ONE Inc.)</li>
                                <li>직위: 대표</li>
                            </ul>
                            <ul>
                                <li><strong>개인정보 관리책임자 (부)</strong></li>
                                <li>이름: 김동희</li>
                                <li>소속: (주)비씨티원 (BCT ONE Inc.)</li>
                            </ul>
                            <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                            <ul>
                                <li>개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                                <li>대검찰청 사이버범죄수사단 (www.spo.go.kr / 02-3480-3571)</li>
                                <li>경찰청 사이버안전국 (www.ctrc.go.kr / 국번없이 182)</li>
                            </ul>

                            <h3>10. 기타</h3>
                            <p>GrowFit에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 "GrowFit 개인정보처리방침"이 적용되지 않음을 알려 드립니다.</p>

                            <h3>11. 고지의 의무</h3>
                            <p>현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다. 다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.</p>
                            <p>- 공고일자: 2025년 3월 5일</p>
                            <p>- 시행일자: 2025년 3월 5일</p>
                        </div>
                        <p className="terms-modal__footer-text">
                            본 개인정보처리방침에 동의하시면 회원가입 페이지에서 동의 체크박스를 선택해 주세요.
                        </p>
                    </div>
                </div>
            )}

            {showBenefitModal && (
                <div className="terms-modal-overlay" onClick={() => setShowBenefitModal(false)}>
                    <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="terms-modal__header">
                            <h2 className="terms-modal__title">광고성 정보 수신 동의 (선택)</h2>
                            <button className="terms-modal__close" onClick={() => setShowBenefitModal(false)} aria-label="닫기">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 6L6 18M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="terms-modal__body">
                            <p><strong>시행일: 2026년 05월 28일</strong></p>
                            <p>
                                GrowFit(이하 "회사")은 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제50조에 따라
                                회원에게 광고성 정보를 전송하기 위해 사전 동의를 받고 있습니다. 본 동의는 선택 사항이며,
                                동의하지 않으셔도 회원가입 및 서비스 이용에는 어떠한 제한도 없습니다.
                            </p>

                            <h3>1. 수신 동의 목적</h3>
                            <ul>
                                <li>그로우핏의 신규 기능 출시 및 업데이트 소식 안내</li>
                                <li>AI 트렌드·튜토리얼·활용 사례 등 학습 콘텐츠 제공</li>
                                <li>이벤트, 프로모션, 할인 쿠폰 등 회원 전용 혜택 안내</li>
                                <li>강의·템플릿·에이전트 신규 등록 및 추천 알림</li>
                                <li>설문, 베타 테스터 모집 등 회원 참여형 이벤트 안내</li>
                            </ul>

                            <h3>2. 전송 정보의 종류</h3>
                            <ul>
                                <li>제품·서비스 업데이트 뉴스레터</li>
                                <li>마케팅·프로모션·이벤트 안내</li>
                                <li>맞춤형 콘텐츠 추천 정보</li>
                            </ul>

                            <h3>3. 전송 채널</h3>
                            <ul>
                                <li>이메일 (회원가입 시 등록한 이메일 주소)</li>
                                <li>서비스 내 인앱 알림</li>
                            </ul>

                            <h3>4. 보유 및 이용 기간</h3>
                            <p>
                                회원 탈퇴 시 또는 수신 동의를 철회한 시점까지 보유·이용하며, 동의 철회 즉시 광고성 정보
                                발송을 중단합니다. 단, 관련 법령에서 정한 보존 기간이 있는 경우 해당 기간 동안 보관됩니다.
                            </p>

                            <h3>5. 동의 철회 방법</h3>
                            <p>회원은 다음 방법으로 언제든지 수신 동의를 철회할 수 있습니다.</p>
                            <ul>
                                <li>서비스 내 [설정 &gt; 알림 설정] 메뉴에서 수신 거부</li>
                                <li>수신한 이메일 하단의 "수신 거부(unsubscribe)" 링크 클릭</li>
                                <li>고객센터 또는 개인정보 관리책임자에게 서면·전화·이메일로 요청</li>
                            </ul>

                            <h3>6. 동의 거부 시 불이익</h3>
                            <p>
                                본 동의는 선택 사항으로, 동의하지 않으시더라도 회원가입 및 GrowFit의 기본 서비스 이용에는
                                제한이 없습니다. 다만, 동의하지 않으실 경우 신규 기능 안내, 이벤트·할인 혜택 등 회원
                                전용 정보를 받아보실 수 없습니다.
                            </p>

                            <h3>7. 야간 광고 전송에 관한 사항</h3>
                            <p>
                                회사는 오후 9시부터 익일 오전 8시까지의 야간 시간대에는 별도의 사전 동의 없이 광고성 정보를
                                전송하지 않습니다. 단, 회원이 야간 수신에 별도로 동의한 경우는 예외로 합니다.
                            </p>

                            <h3>8. 문의처</h3>
                            <ul>
                                <li>운영사: (주)비씨티원 (BCT ONE Inc.)</li>
                                <li>개인정보 관리책임자: 박동민 (대표)</li>
                                <li>이메일 수신 관련 문의는 고객센터를 통해 접수해 주시기 바랍니다.</li>
                            </ul>
                        </div>
                        <p className="terms-modal__footer-text">
                            본 수신 동의에 동의하시면 회원가입 페이지에서 동의 체크박스를 선택해 주세요.
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}
